import React from "react";
import { PlusOutlined } from '@ant-design/icons';
import './BaseStyle.css'
import { Button } from 'antd';
import { checkPermissions } from "@comps/commonFunctions";

const BaseCreate = ({ modkey, permissionAction = "create", text, ...props }) => {
  if (modkey && !checkPermissions(modkey, permissionAction)) {
    return null;
  }

  return (
    <Button className="create-button" type="primary" { ...props }>
      <PlusOutlined />{ text ? text : "Add Record" }
    </Button>
  );
};

BaseCreate.displayName = "BaseCreate";

export default BaseCreate;
